import countriesService from '@/services/countries.service'

export default {
  namespaced: true,
  state: {
    countries: [],
    loading: false,
    error: null
  },
  mutations: {
    SET_COUNTRIES(state, countries) {
      state.countries = countries
    },
    SET_LOADING(state, loading) {
      state.loading = loading
    },
    SET_ERROR(state, error) {
      state.error = error
    },
    ADD_COUNTRY(state, country) {
      state.countries.push(country)
    },
    UPDATE_COUNTRY(state, updatedCountry) {
      const index = state.countries.findIndex(c => c.id === updatedCountry.id)
      if (index !== -1) {
        state.countries.splice(index, 1, updatedCountry)
      }
    },
    REMOVE_COUNTRY(state, id) {
      state.countries = state.countries.filter(c => c.id !== id)
    }
  },
  actions: {
    async fetchCountries({ commit }) {
      try {
        commit('SET_LOADING', true)
        commit('SET_ERROR', null)
        const response = await countriesService.getAll()
        // Handle paginated response - data is nested in response.data.data
        const countries = response.data?.data || response.data || []
        commit('SET_COUNTRIES', countries)
      } catch (error) {
        commit('SET_ERROR', error.response?.data?.message || error.message)
        throw error
      } finally {
        commit('SET_LOADING', false)
      }
    },

    async createCountry({ commit }, countryData) {
      try {
        commit('SET_LOADING', true)
        commit('SET_ERROR', null)
        const response = await countriesService.create(countryData)
        if (response.success) {
          commit('ADD_COUNTRY', response.data)
          return { success: true, data: response.data }
        }
        throw new Error(response.message)
      } catch (error) {
        const errorMessage = error.response?.data?.message || error.message
        commit('SET_ERROR', errorMessage)
        return { success: false, error: errorMessage }
      } finally {
        commit('SET_LOADING', false)
      }
    },

    async updateCountry({ commit }, { id, countryData }) {
      try {
        commit('SET_LOADING', true)
        commit('SET_ERROR', null)
        const response = await countriesService.update(id, countryData)
        if (response.success) {
          commit('UPDATE_COUNTRY', response.data)
          return { success: true, data: response.data }
        }
        throw new Error(response.message)
      } catch (error) {
        const errorMessage = error.response?.data?.message || error.message
        commit('SET_ERROR', errorMessage)
        return { success: false, error: errorMessage }
      } finally {
        commit('SET_LOADING', false)
      }
    },

    async deleteCountry({ commit }, id) {
      try {
        commit('SET_LOADING', true)
        commit('SET_ERROR', null)
        const response = await countriesService.delete(id)
        if (response.success) {
          commit('REMOVE_COUNTRY', id)
          return { success: true }
        }
        throw new Error(response.message)
      } catch (error) {
        const errorMessage = error.response?.data?.message || error.message
        commit('SET_ERROR', errorMessage)
        return { success: false, error: errorMessage }
      } finally {
        commit('SET_LOADING', false)
      }
    }
  },
  getters: {
    allCountries: state => state.countries,
    activeCountries: state => state.countries.filter(c => c.active),
    isLoading: state => state.loading
  }
}

